import DocumentsUpload from './styled';

export default DocumentsUpload;
